module.exports = "<div class=\"q-alert q-alert-grey q-text-center\"> <div>No results match your search. Please adjust your search and or filters to find the results you are looking for.</div> <div>If this problem persists, please call your dedicated Customer Success Specialist for help.</div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/noDataAlert.html
// module id = 1157
// module chunks = 1